import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { IFormCondition } from '@fi-shared/fi-form-shared/fi-form-shared';
import { FiBooleanOperator } from '@fi-shared/types/fi-boolean-operator';
import { FiFormService } from '@fi-app/fi-form/fi-form.service';

@Component({
    selector: 'fi-form-logic-condition-operator-menu',
    template: `
        <button
            mat-flat-button
            [mat-menu-trigger-for]="additionalConditionMenu"
            class="BrandedColor form-add-child-condition-button"
        >
            {{ 'form.condition_add_child_condition_button' | fiAppText }}
        </button>

        <mat-menu #additionalConditionMenu="matMenu">
            <button
                mat-menu-item
                [disabled]="isAndOperatorDisabled()"
                (click)="onAddNewChildConditionClick(FiBooleanOperator.And)"
            >
                {{ 'form.condition_operator_and_if' | fiAppText }}
            </button>
            <button mat-menu-item (click)="onAddNewChildConditionClick(FiBooleanOperator.Or)">
                {{ 'form.condition_operator_or_if' | fiAppText }}
            </button>
        </mat-menu>
    `,
    styleUrls: ['./fi-form-logic-condition-operator-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-form-logic-condition-operator-menu' },
    standalone: false,
})
export class FiFormLogicConditionOperatorMenuComponent {
    @Input() condition: IFormCondition;
    @Output() conditionChange = new EventEmitter<IFormCondition>();

    FiBooleanOperator = FiBooleanOperator;

    constructor(private fiFormService: FiFormService) {}

    isAndOperatorDisabled(): boolean {
        return (
            !!this.condition.ChildItems.length &&
            this.condition.ChildItems.some((childCondition) => {
                return childCondition.ConditionOperator === FiBooleanOperator.Or;
            })
        );
    }

    onAddNewChildConditionClick(operator: FiBooleanOperator): void {
        if (!!this.condition.ChildItems.length) {
            if (this.condition.ConditionOperator === FiBooleanOperator.And && operator === FiBooleanOperator.Or) {
                this.wrapConditionChildrenIntoNewParent(operator);
            }

            this.addChildCondition(operator);
            this.conditionChange.emit(this.condition);
            return;
        }

        this.condition = Object.assign({}, this.convertConditionToComplex(operator));
        this.conditionChange.emit(this.condition);
    }

    private wrapConditionChildrenIntoNewParent(operator: FiBooleanOperator) {
        const previouslyAddedConditionsWrapper = this.getNewCondition(FiBooleanOperator.And);
        previouslyAddedConditionsWrapper.ChildItems = [...this.condition.ChildItems];
        this.condition.ConditionOperator = operator;
        this.condition.ChildItems = [previouslyAddedConditionsWrapper];
    }

    private addChildCondition(operator: FiBooleanOperator): void {
        this.condition.ChildItems.push(this.getNewCondition(operator));
        this.condition = Object.assign({}, this.condition);
    }

    private convertConditionToComplex(operator): IFormCondition {
        const currentConditionCopy = Object.assign({}, this.condition);
        // we should reset some fields
        currentConditionCopy.Id = undefined;
        currentConditionCopy.Actions = undefined;
        this.condition.ConditionType = this.condition.sourceQuestionUid = undefined;
        this.condition.ChildItems = [];

        this.condition.ChildItems.push(currentConditionCopy);
        this.condition.ConditionOperator = operator;
        this.condition.ChildItems.push(this.getNewCondition(operator));
        return this.condition;
    }

    private getNewCondition(operator: FiBooleanOperator): IFormCondition {
        const newCondition: IFormCondition = this.fiFormService.getNewConditionInstance();
        newCondition.Actions = undefined;
        newCondition.ConditionOperator = operator;
        return newCondition;
    }
}
